import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNetworkWired } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-white py-5">
      <Container>
        <Row className="g-4">
          <Col lg={4}>
            <Link 
              to="/" 
              className="d-flex align-items-center text-white text-decoration-none mb-3"
            >
              <FontAwesomeIcon icon={faNetworkWired} className="text-primary me-2" />
              <span className="fw-bold h4 mb-0">DataNest</span>
            </Link>
            <p className="text-muted">
              Connect with data professionals in your area through our privacy-first 
              geospatial networking platform.
            </p>
          </Col>
          
          <Col lg={2} xs={6}>
            <h5 className="mb-3">Navigation</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-muted text-decoration-none">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/#features" className="text-muted text-decoration-none">Features</Link>
              </li>
              <li className="mb-2">
                <Link to="/#how-it-works" className="text-muted text-decoration-none">How It Works</Link>
              </li>
            </ul>
          </Col>
          
          <Col lg={2} xs={6}>
            <h5 className="mb-3">Legal</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/privacy-policy" className="text-muted text-decoration-none">Privacy Policy</Link>
              </li>
              <li className="mb-2">
                <Link to="/terms-of-service" className="text-muted text-decoration-none">Terms of Service</Link>
              </li>
              <li className="mb-2">
                <Link to="/cookie-policy" className="text-muted text-decoration-none">Cookie Policy</Link>
              </li>
            </ul>
          </Col>
          
          <Col lg={4}>
            <h5 className="mb-3">Connect With Us</h5>
            <div className="d-flex gap-3 mb-3">
              <a 
                href="https://twitter.com/your_profile"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted text-decoration-none fs-5"
                aria-label="Twitter Profile"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a 
                href="https://linkedin.com/in/your_profile"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted text-decoration-none fs-5"
                aria-label="LinkedIn Profile"
              >
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
              <a 
                href="https://github.com/your_profile"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted text-decoration-none fs-5"
                aria-label="GitHub Profile"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </div>
            <p className="text-muted small">© {currentYear} DataNest. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
